<template>
    <base-modal
        :reference="'addPickupzone'"
        :title="'Añadir subzona de recogidas'"
        :acceptAction="acceptAction"
        :cancelActionText="'Cerrar'"
        :size="'md'"
    >
        <template v-slot:body v-if="show">
            <div>
                <p>
                    Añadir una nueva subzona de recogidas en {{suprazone.name}}
                </p>
            </div>
            <form>
                
                <div class="d-flex w-100 my-3">
                    <div class="d-flex flex-column align-items-sm-baseline">
                        <label>Nombre de la subzona de recogidas <span class="text-danger">[campo obligatorio]</span></label>
                        <b-form-input
                            type="text"
                            v-model="form.name"
                            placeholder="Inserte nombre"
                            style="width: 17vw"
                        ></b-form-input>
                    </div>
                </div>
                <div v-if="errors">
                    <p class="alert-danger py-2 px-4 my-2 font-weight-bold w-75 mx-auto">
                        El campo nombre es obligatorio
                    </p>
                </div>
            </form>
        </template>

    </base-modal>

</template>

<script>
import BaseModal from "../../Excursions/Booking/Modal/BaseModal";


export default {
    components: {
        BaseModal,
    },
    props: {
        suprazone: {
            type: Object,
            required: false,
        }
    },
    data() {
        return {
            show: false,
            form: {
                name: ''
            }
        }
    },
    async mounted() {
        this.$root.$on("bv::modal::show", async (bvEvent, modalId) => {
            const current = "addPickupzone";
            if (modalId == current) {
                this.show = true
            }
        })
    },
    methods: {
        async acceptAction() {
            if ( this.errors ) {
                return 
            }
            
            let data = {
                suprazone_id: this.suprazone.id,
                payload: {
                    supra_zone: this.suprazone.id,
                    ...this.form
                }
            }
            await this.$store.dispatch("pickupzones/createPickupzone", data )
            
            // reset form data
            this.form = {
                name: '',
            }

            this.$bvModal.hide("addPickupzone");
            this.$notify({
                group: "foo",
                title: "Subzona de recogidas añadida",
                text: "Se ha creado una nueva subzona de recogidas",
                type: "success",
            });
        }
    },
    computed: {
        errors() {
            if ( this.form.name == '') {
                return true
            }
            return false
        }
    }
}
</script>